import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { vueGet } from '@/api/vue';

export const useEditorDiffModal = defineStore('editorDiffModal', () => {
  // State
  const fetchedRevisions = ref([]);
  const currentRevision = ref(null);
  const selectedHistoricalRevision = ref(null);
  const prevHistoricalRevision = ref(null);
  const nextHistoricalRevision = ref(null);
  const page = ref(2);
  // Getter
  const loading = computed(() => !currentRevision.value || !selectedHistoricalRevision.value);

  // Mutations
  const setRevision = ({ revision, field }) => {
    if (field === 'currentRevision') currentRevision.value = revision;
    if (field === 'selectedHistoricalRevision') selectedHistoricalRevision.value = revision;
    if (field === 'prevHistoricalRevision') prevHistoricalRevision.value = revision;
    if (field === 'nextHistoricalRevision') nextHistoricalRevision.value = revision;
  };

  const setPage = (pageToSet) => {
    page.value = pageToSet;
  };

  const resetDiff = () => {
    currentRevision.value = null;
    selectedHistoricalRevision.value = null;
    prevHistoricalRevision.value = null;
    nextHistoricalRevision.value = null;
    page.value = 2;
  };

  const appendToFetchedRevisions = (revision) => {
    fetchedRevisions.value = [...fetchedRevisions.value, revision];
  };

  const getRevision = async ({
    jobId, revisionId, field,
  }) => {
    let revision;
    if (revisionId) {
      const revisionInState = fetchedRevisions.value
        .filter((fetchedRevision) => fetchedRevision.id === revisionId)[0];

      if (revisionInState) {
        revision = revisionInState;
      } else {
        revision = await vueGet({ id: jobId, revision: revisionId });
        revision.isCurrent = false;
        appendToFetchedRevisions(revision);
      }
    } else {
      revision = await vueGet({ id: jobId });
      revision.isCurrent = true;
    }

    setRevision({ revision, field });
  };

  const getHistoricalRevisions = ({
    selectedHistoricalId, previousHistoricalId, nextHistoricalId, jobId,
  }) => {
    if (selectedHistoricalId) {
      getRevision({
        jobId, revisionId: selectedHistoricalId, field: 'selectedHistoricalRevision',
      });
    }

    if (previousHistoricalId) {
      getRevision({
        jobId, revisionId: previousHistoricalId, field: 'prevHistoricalRevision',
      });
    }

    if (nextHistoricalId) {
      getRevision({
        jobId, revisionId: nextHistoricalId, field: 'nexHistoricaltRevision',
      });
    }
  };

  // Actions
  const initDiffModal = ({
    selectedHistoricalId, previousHistoricalId, nextHistoricalId, jobId,
  }) => {
    getRevision({ jobId, field: 'currentRevision' });
    getHistoricalRevisions({
      selectedHistoricalId, previousHistoricalId, nextHistoricalId, jobId,
    });
  };

  return {
    // State
    fetchedRevisions,
    currentRevision,
    selectedHistoricalRevision,
    prevHistoricalRevision,
    nextHistoricalRevision,
    page,
    // Actions
    loading,
    setRevision,
    setPage,
    resetDiff,
    appendToFetchedRevisions,
    initDiffModal,
    getHistoricalRevisions,
    getRevision,
  };
});
